import { inject, Injectable, signal } from '@angular/core';
import { UserUI } from '@src/models';

import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  readonly allowViewingNotificationDialog = signal<boolean>(false);
  readonly allowViewingProfileDialog = signal<boolean>(false);

  private readonly storage = inject(StorageService);

  getPermissions(isCordova: boolean, user: UserUI) {
    this.allowViewingNotificationDialog.set(isCordova && this.storage.isFirstDeviceLogin());

    this.allowViewingProfileDialog.set(!!(user.isFirstSignIn && !user.permissions?.includes('showOnlyLoyaltyProgram')));
  }
}
